/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_View_LabelInputs */

const en_admin_ai_chat_view_label = /** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const de_admin_ai_chat_view_label = /** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht`)
};

const es_admin_ai_chat_view_label = /** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista`)
};

const fr_admin_ai_chat_view_label = /** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage`)
};

const nl_admin_ai_chat_view_label = /** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weergave`)
};

/** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */
const it_admin_ai_chat_view_label = en_admin_ai_chat_view_label;

/** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_view_label = en_admin_ai_chat_view_label;

/** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */
const pl_admin_ai_chat_view_label = en_admin_ai_chat_view_label;

/** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */
const hu_admin_ai_chat_view_label = en_admin_ai_chat_view_label;

/** @type {(inputs: Admin_Ai_Chat_View_LabelInputs) => LocalizedString} */
const ro_admin_ai_chat_view_label = en_admin_ai_chat_view_label;

/**
* | output |
* | --- |
* | "View" |
*
* @param {Admin_Ai_Chat_View_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_view_label = /** @type {((inputs?: Admin_Ai_Chat_View_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_View_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_view_label(inputs)
	if (locale === "de") return de_admin_ai_chat_view_label(inputs)
	if (locale === "es") return es_admin_ai_chat_view_label(inputs)
	if (locale === "fr") return fr_admin_ai_chat_view_label(inputs)
	if (locale === "nl") return nl_admin_ai_chat_view_label(inputs)
	if (locale === "it") return it_admin_ai_chat_view_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_view_label(inputs)
	if (locale === "pl") return pl_admin_ai_chat_view_label(inputs)
	if (locale === "hu") return hu_admin_ai_chat_view_label(inputs)
	return ro_admin_ai_chat_view_label(inputs)
});
export { admin_ai_chat_view_label as "admin.ai_chat.view_label" }